:host(.pds-copytext) {
  // Update custom prop usage in Button before changing
  --copytext-color-background-hover: var(--pine-color-background-inset);


  pds-button {
    align-items: center;
    border-radius: var(--pine-border-radius-full);
    border-width: var(--pine-dimension-none);
    display: inline-flex;
    font-family: var(--pine-font-family-heading);
    font-size: var(--pine-font-size-body-md);
    font-weight: var(--pine-font-weight-body-medium);
    letter-spacing: var(--pine-letter-spacing);
    line-height: var(--pine-line-height-body);
    max-width: 100%;

    &::part(button) {
      padding-block: var(--pine-dimension-2xs);
      padding-inline: var(--pine-dimension-xs);
    }

    &::part(button):hover {
      // Update custom prop usage in Button before changing
      background-color: var(--copytext-color-background-hover);
      color: var(--pine-color-text-secondary-hover);
    }

    span {
      font-weight: var(--pine-font-weight-medium);
      margin-inline-end: var(--pine-dimension-xs);
      white-space: nowrap;
    }

    :nth-child(2) {
      flex-shrink: 0;
    }
  }

  // bordered

  &:host(.pds-copytext--bordered) {
    border-width: var(--pine-dimension-none);
    padding: var(--pine-dimension-none);

    pds-button {
      padding: var(--pine-dimension-none);

      &::part(button) {
        padding: var(--pine-dimension-none);
      }

      &::part(button):hover {
        background-color: transparent;
      }
    }

    span {
      background: var(--pine-color-secondary);
      border: var(--pine-border);
      border-radius: var(--pine-border-radius-full);
      margin-inline-end: var(--pine-dimension-sm);
      padding-block: var(--pine-dimension-xs);
      padding-inline: var(--pine-dimension-sm);
    }

    :hover {
      span {
        border: var(--pine-border-hover);
      }
    }
  }

  // full width and truncated
  &:host(.pds-copytext--full-width),
  &:host(.pds-copytext--truncated) {
    pds-button {
      display: inline-flex;
      min-width: auto;
      width: 100%;

      &::part(button-content),
      &::part(button-text) {
        flex-shrink: 1;
        width: 100%;
      }

      span {
        text-align: start;
        width: 100%;
      }
    }
  }

  // full width
  &:host(.pds-copytext--full-width) {
    pds-button {
      justify-content: space-between;
    }
  }

  // truncated
  &:host(.pds-copytext--truncated) {
    pds-button span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
